import { useAuth0 } from "@auth0/auth0-react";
import {
  Button,
  Colors,
  Icon,
  Menu,
  MenuItem,
  Popover,
} from "@blueprintjs/core";

function MenuAccount({ onLogOut }: { onLogOut: () => void }) {
  return (
    <Menu>
      <MenuItem icon="log-out" text="Log Out" onClick={() => onLogOut()} />
    </Menu>
  );
}

type AccountMenuProps = {
  /** "compact" is an icon-only trigger for a navbar; "full" is a labeled, full-width row for a sidebar. */
  variant?: "compact" | "full";
};

export function AccountMenu({ variant = "compact" }: AccountMenuProps) {
  const { logout } = useAuth0();

  return (
    <Popover
      content={
        <MenuAccount
          onLogOut={() =>
            logout({ logoutParams: { returnTo: location.origin } })
          }
        />
      }
      placement={variant === "full" ? "top-start" : "bottom"}
    >
      {variant === "full" ? (
        <Button minimal fill alignText="left" icon="user" text="Account" />
      ) : (
        <Button title="Profile" minimal>
          <Icon icon="user" style={{ color: Colors.WHITE }} />
        </Button>
      )}
    </Popover>
  );
}
